import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import { getOrders, selectOrders } from '../orders';
import { selectServices } from '../../app/services';
import Icon from '../../../ui/Icon';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IsSpinning from '../../app/containers/IsSpinning';
import Order from '../components/Order';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/List.scss';
import Table from '../../../ui/Table';
import {SessionRequired} from '../../../lib/api/components/SessionRequired';
import Button from "../../../ui/Button";
import Helmet from "react-helmet";

@injectIntl
export class OrdersList extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        orders: ImmutablePropTypes.orderedMap.isRequired,
        services: ImmutablePropTypes.map.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        intl: intlShape,
    }

    componentWillMount() {
        this.props.dispatch(getOrders());
    }

    render() {
        const { orders, services, dispatch, session, spinner } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Page.Body>
                <Helmet title={formatMessage({ id: 'frontend.pagetitle.orders' })} />
                <SessionRequired dispatch={dispatch} session={session}>
                    <Page.Section depth={0}>
                        <h1>
                            <FormattedMessage id='frontend.orders.headline' />
                        </h1>
                    </Page.Section>
                    <Page.Section>
                        <Table>
                            <Table.Row type='header' className={styles.headerRow}>
                                <Table.Cell className={styles.headerCell}>Bestellung</Table.Cell>
                                <Table.Cell className={styles.headerCell}>Erstellt</Table.Cell>
                                <Table.Cell className={styles.headerCell}>Service</Table.Cell>
                                <Table.Cell className={styles.headerCell}>Aktueller Status</Table.Cell>
                            </Table.Row>
                            {
                                orders.size === 0 && !spinner.get('orders') ?
                                    (<div className={styles.emptyContainer} key={'0'}>
                                        <h3>
                                            <FormattedMessage id='frontend.orders.dashboard.no_orders' />
                                        </h3>
                                    </div>) :
                                    orders.map(order => <Order
                                        key={order.get('id')}
                                        order={order}
                                        services={services}
                                    />)
                                        .toArray()
                            }
                        </Table>
                        <IsSpinning id='orders'>
                            <div className={styles.loadingMessage}>
                                <Icon name='refresh' spin fixedWidth />{' '}
                                <FormattedMessage id='common.helper.please_wait' />
                            </div>
                        </IsSpinning>
                        {(orders.size === 0 && !spinner.get('orders')) ? (
                            <Button link to='/order/region' emphasis='primary' block>
                                <FormattedMessage id='frontend.orders.dashboard.new_order' />
                            </Button>) : null}
                    </Page.Section>
                </SessionRequired>
            </Page.Body>
        );
    }
}

export default withRouter(connect(state => ({
    orders: selectOrders(state),
    services: selectServices(state),
    session: state.session,
    spinner: state.spinner,
}))(OrdersList));
